<template>
    <div>
        <div class="row top">
            <div class="row">
                <div class="col-md-2">
                    <back-button returnUrl="/home"></back-button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <h4><u>Παρουσίες</u></h4>
                </div>
            </div>

            <div>
                <DxLoadIndicator
                    id="image-indicator"
                    :height="40"
                    :width="40"
                    :visible="loadIndicatorVisible"
                />
            </div>
        </div>

        <div class="row">
            <div class="col-md-3">
                <DxSelectBox
                    :search-enabled="true"
                    :data-source="months"
                    search-mode="contains"
                    search-expr="Description"
                    :search-timeout="200"
                    :min-search-length="2"
                    :show-data-before-search="true"
                    display-expr="Description"
                    value-expr="Id"
                    v-model="selectedMonthId"
                    @value-changed="setSelectedMonth"
                    placeholder="Επιλέξτε Μήνα"
                    :show-clear-button="true"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 grid-pad">
                <DxDataGrid
                    :data-source="attendances"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :show-row-lines="true"
                    :row-alternation-enabled="true"
                    width="100%"
                >
                    <DxPaging :page-size="20" :enabled="true" />
                    <DxEditing :allow-updating="false" :use-icons="true" mode="cell" />
                    <DxHeaderFilter :visible="true" />
                    <DxFilterRow :visible="true" />
                    <DxSearchPanel :visible="true" />

                    <DxColumn
                        caption="Ημερομηνία"
                        :allow-editing="false"
                        data-field="AttendanceDate"
                        data-type="date"
                        :visible="true"
                        width="200px"
                        alignment="center"
                        format="dd/MM/yyyy"
                        :allow-filtering="true"
                    >
                    </DxColumn>
                    <DxColumn
                        caption="Δομή"
                        :allow-editing="false"
                        data-field="StructureDescription"
                        data-type="string"
                        :visible="true"
                        width="400px"
                        alignment="left"
                    >
                    </DxColumn>
                    <DxColumn
                        caption="Επιβεβαιωμένες"
                        data-field="IsValid"
                        :allow-editing="false"
                        :visible="true"
                        width="150px"
                        alignment="right"
                    >
                    </DxColumn>
                    <DxColumn
                        caption="Μη Επιβεβαιωμένες"
                        data-field="IsNotValid"
                        :allow-editing="false"
                        :visible="true"
                        width="150px"
                        alignment="right"
                    >
                    </DxColumn>
                    <DxColumn
                        caption="Απουσίες"
                        data-field="HasNotAttended"
                        :allow-editing="false"
                        :visible="true"
                        width="100px"
                        alignment="right"
                    >
                    </DxColumn>
                    <DxColumn type="buttons">
                        <DxButton
                            hint="Πληροφορίες"
                            icon="info"
                            :on-click="onAttendanceInfoClick"
                        />
                    </DxColumn>
                </DxDataGrid>
            </div>
        </div>
    </div>
</template>

<script>
import BackButton from "../../components/shared/backButton";
import { DxSelectBox } from "devextreme-vue/select-box";
import mainService from "../../services/mainService";
import {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxPaging,
    DxFilterRow,
    DxSearchPanel,
    DxEditing,
    DxButton,
} from "devextreme-vue/data-grid";
import router from "../../router";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";

export default {
    components: {
        BackButton,
        DxSelectBox,
        DxDataGrid,
        DxColumn,
        DxHeaderFilter,
        DxPaging,
        DxFilterRow,
        DxSearchPanel,
        DxEditing,
        DxButton,
        DxLoadIndicator,
    },
    
    data() {
        return {
            months: [],
            selectedMonthId: 0,
            attendances: [],
            loadIndicatorVisible: false,
        };
    },

    created() {},

    methods: {
        async setSelectedMonth(e) {
            this.loadIndicatorVisible = true;

            this.attendances = [];

            if (this.hasFullAccess) {
                const res = await mainService.get(`/Attendances/GetAttendanceRecordsForMainIndex?organizationId=${this.organizationId}&month=${this.selectedMonthId}`);
                this.attendances = res.data;
            }

            this.loadIndicatorVisible = false;
        },

        onAttendanceInfoClick(e) {
            router.replace(`/attendancesdetails/${e.row.data.StructureId}/${this.$moment(e.row.data.AttendanceDate).format("YYYY-MM-DD")}`);
        },
    },

    watch: {
        organizationId: async function (newValue, oldValue) {
            this.setSelectedMonth(null);
        },
    },

    computed: {
        organizationId() {
            return this.$store.getters.getSelectedOrganizationId;
        },
        hasFullAccess() {
            return this.$store.getters.getHasFullAccess;
        },
    },

    async mounted() {
        const res1 = await mainService.get(`/Periods/GetAvailableMonthsInActivePeriod`);
        this.months = res1.data;

        this.selectedMonthId = parseInt(this.$moment().format("M"));

        this.setSelectedMonth(null);
    },
};
</script>
